import { useLanguage } from "@/i18n/LanguageContext";
const outcomes = [
  { t: "Increase factory output", d: "Find hidden capacity in existing machines before investing in new equipment. Improve line availability, reduce micro-stops and make every shift accountable." },
  { t: "Increase profit per shift", d: "Reduce losses from downtime, waiting, scrap, rework, energy waste and manual coordination." },
  { t: "Improve OEE", d: "Use real-time OEE to understand availability, performance and quality losses by machine, line, product, order and shift." },
  { t: "Reduce unplanned downtime", d: "Combine machine monitoring, downtime reasons, alerts, Andon and maintenance workflows to react faster." },
  { t: "Control material flow", d: "Track raw materials, WIP and finished goods with QR codes, batch genealogy and consumption confirmations." },
  { t: "Improve quality", d: "Digitize inspections and connect quality results to production orders, operators, machines and batches." },
  { t: "Reduce energy waste", d: "Measure energy consumption by machine and production context, not only by monthly utility invoice." },
  { t: "Faster management decisions", d: "Give executives and plant managers live facts instead of delayed Excel reports." },
];

export default function BusinessOutcomes() {
  const { t } = useLanguage();
  return (
    <section className="py-16 md:py-20 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-10">
          <p className="eyebrow mb-3">{t("Outcomes")}</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">{t("BEEDIGIT is built for business results, not only digital dashboards.")}</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          {outcomes.map((o) => (
            <div key={o.t} className="rounded-lg border border-border bg-card p-4">
              <h3 className="font-semibold mb-2">{t(o.t)}</h3>
              <p className="text-sm text-muted-foreground">{t(o.d)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}